import { fromPairs, map } from 'ramda';
import Promise from 'bluebird';
import $ from 'jquery';
import JSZip from 'jszip';

const readExcelFile = (cells, sheetNum, zip) => {
  const invalidFile = () => { throw new Error('Invalid File') };

  const sheetName = `xl/worksheets/sheet${sheetNum}.xml`;
  if (typeof zip.files[sheetName] === 'undefined') {
    return invalidFile();
  }

  const xmlData = zip.folder('xl').folder('worksheets').file(`sheet${sheetNum}.xml`).asText();
  const $xml = $($.parseXML(xmlData));

  const getCell = (cellId) => {
    const cells = $xml.find(`c[r='${cellId}']`);
    return [cellId, cells.length ? $(cells[0]).children('v')[0].innerHTML : null];
  }

  return fromPairs(map(getCell, cells));
}

export default function (cells, sheetNum, file) {
  const reader = new FileReader();

  const dataPromise = new Promise((resolve, reject) => {
    reader.onload = (event) => {
      try {
        resolve(readExcelFile(cells, sheetNum, new JSZip(event.target.result)));
      } catch (e) {
        reject(e);
      }
    };
  });

  reader.readAsArrayBuffer(file);
  return dataPromise;
};



// WEBPACK FOOTER //
// ./src/modules/readExcel.js